module.exports = __webpack_public_path__ + "img/add-red.006c53b7.svg";